import {useEffect, useRef, useState} from "react";

import baseUrl from "../../../../baseUrl";
import {requester} from "../../../../services/requester";
import {AreaField} from "./AreaField";
import {useCloseForm} from "../useCloseForm";

// Н5 — екранът „БП и пътища". Двата реда са същите като преди; новото е, че
// стоят на СВОЙ таб, за да не се пропускат в работния процес, и че записът тук
// гаси червения „!" — включително когато стойностите са нули.
//
// Формата пише САМО своите две полета (PUT /others/bp-roads/...). Другите площи
// и корекцията не се пипат, тоест двама души на двата екрана не се презаписват.
export const BpRoadsForm = ({bullstat, settlement_ekatte, year, onOthersSubmit, othersInfo}) => {
    const request = requester();
    const closeForm = useCloseForm();
    const anchor = useRef(null);
    const [values, setValues] = useState({white_spots: 0, roads: 0});
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setValues({
            white_spots: othersInfo?.white_spots ?? 0,
            roads: othersInfo?.roads ?? 0,
        });
    }, [othersInfo]);

    // Н6: превърта до САМАТА форма, а не до дъното на страницата. Старият начин
    // (`window.scroll` до `document.body.offsetHeight`) мереше височината, преди
    // формата да е разположена — затова изглеждаше, че нищо не се случва.
    useEffect(() => {
        anchor.current?.scrollIntoView({behavior: "smooth", block: "center"});
    }, []);

    const change = (e) => setValues(prev => ({...prev, [e.target.name]: e.target.value}));

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await request.put(
                `${baseUrl()}/others/bp-roads/${year}/${settlement_ekatte}/${bullstat}`,
                {white_spots: Number(values.white_spots) || 0,
                 roads: Number(values.roads) || 0});
            onOthersSubmit();
            alert("Белите петна и пътищата са записани.");
            closeForm();                     // Р2: обратно най-горе
        } catch (err) {
            alert(err.message || 'Възникна грешка при заявката.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={onSubmit} ref={anchor}>
            <h5 style={{color: "var(--app-gold)"}}>Бели петна и пътища</h5>
            <p className="text-muted" style={{fontSize: "0.9rem"}}>
                Двете площи <strong>увеличават</strong> правното основание.
                Записът маха предупредителния знак от таба — и когато стойностите
                са нули, защото важното е екранът да е минал през вас.
            </p>

            <AreaField id="white-spots" label="Бели петна" name="white_spots"
                       min="0" placeholder="Въведи площ бели петна"
                       value={values.white_spots} onChange={change}/>
            <AreaField id="roads" label="Пътища" name="roads"
                       min="0" placeholder="Въведи площ пътища"
                       value={values.roads} onChange={change}/>

            <button type="submit" className="btn btn-primary mt-3" disabled={busy}>
                {busy ? "Записва се…" : "Запиши"}
            </button>
        </form>
    );
};
